<div>
	<!-- <ion-toolbar color="primary"> -->
	<h4>Details: </h4>
	<!-- </ion-toolbar> -->
</div>

<mat-grid-list [cols]="1">
	@if (deviceData != null) {
<div
	
		class="sample">
		<p><strong>Terminal Id:</strong> {{ deviceData.TerminalID }}</p>
		<p><strong>IMEI:</strong> {{ deviceData.IMEI }}</p>
		<p><strong>Terminal Supplier:</strong> {{ deviceData.TerminalSupplier }}</p>
		<p><strong>Acquiring Bank:</strong> {{ deviceData.AcquiringBank }}</p>
		<p><strong>SCID:</strong> {{ deviceData.SCID }}</p>
		<p
			class="cursor text-center"
			(click)="viewDetails()"
			>View Details</p
		>
		<p
			class="cursor text-center"
			(click)="closeModal()"
			>Close</p
		>
	</div>
}
</mat-grid-list>
